import { Link } from 'react-router-dom';
import { footerLinks } from '@/mocks/home';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5 pointer-events-none select-none flex items-center justify-center">
        <span className="text-[12rem] font-heading font-black whitespace-nowrap tracking-tighter">黑料在线</span>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block cursor-pointer">
              <span className="text-2xl font-heading font-bold text-white">黑料在线</span>
            </Link>
            <p className="mt-4 text-sm text-white/50 leading-relaxed max-w-xs">
              每日更新最新网红黑料、明星八卦、娱乐圈爆料。黑料在线，吃瓜第一线，让你不错过任何热点。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {footerLinks.social.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-primary-500 transition-colors cursor-pointer"
                  title={item.name}
                  rel="nofollow"
                >
                  <i className={`${item.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.map((item) => (
                <li key={item.name}>
                  <Link to={item.href} className="text-sm text-white/50 hover:text-white transition-colors cursor-pointer">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              {footerLinks.about.map((item) => (
                <li key={item.name}>
                  <Link to={item.href} className="text-sm text-white/50 hover:text-white transition-colors cursor-pointer">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">订阅每日爆料</h4>
            <p className="text-sm text-white/50 mb-3">第一时间获取最新黑料推送</p>
            <form className="flex" data-readdy-form="">
              <input
                type="email"
                name="email"
                placeholder="输入邮箱地址"
                className="flex-1 bg-white/10 border border-white/20 rounded-l-full px-4 py-2.5 text-sm text-white placeholder:text-white/30 outline-none focus:border-primary-400 transition-colors"
              />
              <button
                type="submit"
                className="bg-primary-500 hover:bg-primary-600 text-white px-5 rounded-r-full font-medium text-sm whitespace-nowrap cursor-pointer transition-colors"
              >
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </button>
            </form>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/30">
            &copy; 2026 黑料在线网 - 版权所有 | 内容仅供娱乐参考
          </p>
          <p className="text-xs text-white/30">
            黑料在线观看 · 黑料在线吃瓜 · 黑料在线视频
          </p>
        </div>
      </div>
    </footer>
  );
}